module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/2dbfac58a99f6f1bbd66a23a6519ef10.png";